(function () {
    'use strict';

    function ImageUploadController($scope, $attrs, $element) {
//
        var $ctrl = this;
        $ctrl.myImage = '';
        $ctrl.myCroppedImage = '';
        $ctrl.cropImage = cropImage;

        // var el = document.getElementById('image-cropper');
        // debugger;
        // $ctrl.imageCropper = new Croppie(el, {
        //     viewport: { width: $ctrl.cropWidth, height: $ctrl.cropHeight },
        //     boundary: { width: $ctrl.minWidth, height: $ctrl.minHeight},
        //     showZoomer: true
        // });


        var handleFileSelect = function (evt) {

            var file = evt.currentTarget.files[0];

            var tempUrl = URL.createObjectURL(file);


            $ctrl.imageCropper.bind({
                url: tempUrl,
                zoom: 0.5
            });
        };

        function cropImage() {

            $ctrl.imageCropper.result('blob').then(function (blob) {

                $ctrl.myCroppedImage = "";
                var tempUrl = URL.createObjectURL(blob);
                $ctrl.myCroppedImage = tempUrl;

                if ($ctrl.onCroppedDone)
                    $ctrl.onCroppedDone();

                // var reader = new FileReader();
                // reader.onload = function (blob) {
                //     $scope.$apply(function($scope){
                //
                //
                //     });
                // };
            });
        }


        var handleFileSelect2 = function (evt) {


            var reader = new FileReader();
            reader.onload = function (e) {
                $ctrl.imageSrc = evt.target.result;
            };

            var file = evt.currentTarget.files[0];
            reader.readAsDataURL(file);
            setTimeout(initCropper, 1000);
        };
        angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect2);

        setTimeout(initCropper, 1000);

        function initCropper() {
            var imageElem = document.getElementById('original-image');

            var minCroppedWidth = 119;
            var minCroppedHeight = 119;
            var maxCroppedWidth = 120;
            var maxCroppedHeight = 120;

            var cropper = new Cropper(imageElem, {
                // aspectRatio: 40 / 24,
                movable: false,
                zoomable: false,
                rotatable: false,
                scalable: false,
                cropBoxResizable: false,
                viewMode: 2,
                // data: {
                //     // width: 400,
                //     // height: 240,
                //     width: maxCroppedWidth
                //     // height: (minCroppedHeight + maxCroppedHeight) / 2,
                // },
                //
                crop: function (event) {
                    var width = event.detail.width;
                    var height = event.detail.height;

                    if (
                        width < minCroppedWidth
                        || height < minCroppedHeight
                        || width > maxCroppedWidth
                        || height > maxCroppedHeight
                    ) {
                        cropper.setData({
                            width: Math.max(minCroppedWidth, Math.min(maxCroppedWidth, width)),
                            height: Math.max(minCroppedHeight, Math.min(maxCroppedHeight, height)),
                        });
                    }

                }
            });
        }
    }

    var ImageUpload = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/image-upload/eyeson.image-upload.html',
        controller: ImageUploadController,
        bindings:
            {
                cropWidth: '<?',
                cropHeight: '<?',
                minWidth: '<?',
                minHeight: '<?',
                croppedImage: '=?',
                onCroppedDone: "=?"

            }

    };

    angular
        .module('tikonApp')
        .component('eoImageUpload', ImageUpload)

    ImageUploadController.$inject = ['$scope', '$attrs', '$element'];


})();

